import clsx from "clsx";

export const uiOutlineClass = clsx(
  "focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
);
